export default "__VITE_PUBLIC_ASSET__6833cb96__"